import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { fetchEmployeesForm, selectFormFields, selectFormFirstLoad, selectFormId, selectFormLoading } from "../model"
import { useEffect } from "react"
import { FormBuilder } from "@/widgets/formbuilder"

export const EmployeesProfilebuilderPage = () => {
    const employeesFormFirstLoad = useAppSelector(selectFormFirstLoad)
    const dispatch = useAppDispatch()
    const employeesFormLoading = useAppSelector(selectFormLoading)
    const employeesFormId = useAppSelector(selectFormId)
    const employeesForm = useAppSelector(selectFormFields)

    const onUpdate = () => {
        dispatch(fetchEmployeesForm())
    }

    useEffect(() => {
        if (employeesFormFirstLoad) {
            dispatch(fetchEmployeesForm())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Сотрудники" />
            <div className='flexbox'>
                <PageSubtitle title="Конструктор профиля" />
                <FormBuilder 
                    formId={employeesFormId}
                    update={onUpdate}
                    fields={employeesForm} 
                    isLoading={employeesFormLoading} 
                />
            </div>
        </div>
    )
}